import { AuthenticationService } from './../../shared/authentication.service';
import { QATicket, Question, QAResponse } from './../../shared/qaTicket';
import { QuestionService } from './../../shared/questionService';
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from '@angular/router';
import { InfodialogComponent } from '../../dialogs/infodialog/infodialog.component';
import { MatDialog } from '@angular/material';
import { isNullOrUndefined } from 'util';

@Component({
  selector: "app-disputequalityticketnotes",
  templateUrl: "./disputequalityticketnotes.component.html",
  styleUrls: ["./disputequalityticketnotes.component.scss"]
})

export class DisputequalityticketnotesComponent implements OnInit {
  subject: string = "";
  message: string = "";
  appendmessage: string = "";
  submitted = false;
  qaTicket = new QATicket();
  ticketQuestions = new Array<Question>();
  mismatchQuestions = new Array<QAResponse>();
  selectedquestion: number;
  username: string = "";
  disputeUser: string = "";
  constructor(
    public questionService: QuestionService,
    public route: ActivatedRoute,
    public dialog: MatDialog,
    public auth: AuthenticationService
  ) {
    this.qaTicket.ID = route.snapshot.params['number'];
    this.username = route.snapshot.params['name'];
    this.username = this.username.replace("-", ".");
  }

  ngOnInit() {
    this.questionService.getQATicketByQATicketId(this.qaTicket.ID, this.auth.currentState).then(data => {
      if (data.QATicket != null) {
        this.qaTicket = data.QATicket;
        this.ticketQuestions = data.TicketQuestions;
        this.qaTicket.Response.forEach(response => {
          const question = this.ticketQuestions.find(x => x.ID === response.QuestionID);
          response.QuestionText = question.QuestionText;
          response.Section = question.Section;
          response.CanNA = question.CanNA;
        });
        this.qaTicket.Response.forEach(response => {
          
          if (response.ResponseValue !== 'na') {
            if (response.ResponseValue !== response.ValidResponse) {
              if (response.ValidResponse.toLowerCase() == 'multiresponses') {
                if(response.CriticalLevel <= -1){
                  this.mismatchQuestions.push(response);
                }
              } else {
                this.mismatchQuestions.push(response);
              }
            }
          }
        });
      }
    });
    if(isNullOrUndefined(this.username) || this.username === "") {
      this.subject = "Dispute Open";
    }
  }

  OnDisputeClick() {
    if(this.subject.toLowerCase() === "dispute open") {
      this.appendmessage = "Dispute Open" + " - " + this.message;
    }
    else
    {
      this.appendmessage = this.subject + " - " + this.message;
      this.subject = "Dispute Open";
    }
    if (isNullOrUndefined(this.username) || this.username == "") {
      this.disputeUser = this.qaTicket.GCTicketTakenBy;
    }
    else {
      this.disputeUser = this.username;
    }
    this.questionService.addQualityNotesAndAddDisputeActivity(this.qaTicket.ID, this.disputeUser, this.subject, this.appendmessage, 'dispute', this.selectedquestion, this.auth.currentState, this.auth.token).subscribe(res => {
      if (res.toString().toLowerCase() === 'this ticket is disputed') {
        this.subject = "";
        this.message = "";
        let infoalert = this.dialog.open(InfodialogComponent, {
          width: '500px',
          data: {
            title: 'Alert',
            content: 'This ticket is already disputed with selected question. Please contact QA Department.'
          }
        });
      }
      else {
        this.subject = "";
        this.message = " ";
        this.selectedquestion = 0;
        let infoalert = this.dialog.open(InfodialogComponent, {
          width: '500px',
          data: {
            title: 'Alert',
            content: 'Ticket is disputed.'
          }
        });
      }
    });
  }

  showErrors(form) {
    this.submitted = true;
    form.form.controls.Subject.touched = true;
    form.form.controls.Message.touched = true;
    form.form.controls.selectedquestionname.touched = true;
  }
}
